import { render, staticRenderFns } from "./SalesOrdersCreate.vue?vue&type=template&id=054dcd1f"
import script from "./SalesOrdersCreate.vue?vue&type=script&lang=js"
export * from "./SalesOrdersCreate.vue?vue&type=script&lang=js"
import style0 from "./SalesOrdersCreate.vue?vue&type=style&index=0&id=054dcd1f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports